export default __webpack_public_path__ + "static/media/antro.c989cb17.png";